import { render } from "./EventsHome.vue?vue&type=template&id=488a0726&scoped=true"
import script from "./EventsHome.vue?vue&type=script&lang=js"
export * from "./EventsHome.vue?vue&type=script&lang=js"

import "./EventsHome.vue?vue&type=style&index=0&id=488a0726&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488a0726"]])

export default __exports__